export default "__VITE_ASSET__35b0a67f__"